import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { SidenavComponent } from '../../sidenav.component';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  needChangePassword: boolean;
  
  @Input() sidenav: SidenavComponent;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.needChangePassword = this.authService.needChangePassword();

    this.authService
      .passwordChanged()
      .subscribe(() => this.onPasswordChanged());
  }

  private onPasswordChanged() {
    this.needChangePassword = false;
    this.sidenav.controller.disableClose = false;
  }
}
